import CategoriaForm from "./CategoriaForm";
export default CategoriaForm;